module.exports = __webpack_public_path__ + "img/arrow.3e823a86.svg";